<template>
  <el-empty v-if="!detail" />
  <full-container v-else>
    <div class="wrap">
      <images :objectId="detail.Id" height="320" />
      <dl>
        <dd>
          <h1>{{ detail.Name }}</h1>
        </dd>
        <dd>
          <label class="text-price text-danger" style="font-size: 24px">{{ detail.Price }}</label>
          /{{ detail.Unit }}
        </dd>
        <template v-if="detail.Remark">
          <dt>商品介绍</dt>
          <dd style="white-space: pre-wrap">{{ detail.Remark }}</dd>
        </template>
        <template v-if="items.length > 0">
          <dt>商品清单</dt>
          <dd>
            <table>
              <tr v-for="item in items" :key="item.Id">
                <td>{{ item.Name }}</td>
                <td>{{ item.Amount }}{{ item.Unit }}</td>
              </tr>
            </table>
          </dd>
        </template>
      </dl>
    </div>
    <div slot="footer" class="ft">
      <el-button type="primary" @click="$router.replace({ path: `form/${detail.Id}` })">修改</el-button>
      <el-button type="danger" @click="onDelete()">删除</el-button>
      <el-button type="info">打印</el-button>
    </div>
  </full-container>
</template>

<script>
export default {
  components: {
    images: () => import('@/views/system/file/show.vue')
  },
  data () {
    return {
      detail: null,
      items: []
    }
  },
  created () {
    let id = this.$route.params?.id
    if (id) {
      this.loadData(id)
    }
  },
  methods: {
    loadData (id) {
      this.$apis.mall.goods.info({ id: id }).then(res => {
        this.detail = res
        return this.$apis.mall.goods.getItems({
          goodsId: id
        })
      }).then(res => {
        this.items = res
      })
    },
    //删除
    onDelete () {
      this.$confirm("此操作将永久删除数据不可恢复, 是否继续?", `删除`, {
        center: true,
      }).then(() => {
        this.$apis.mall.goods.delete({ id: this.detail.Id }).then(() => {
          this.$message({ message: "已删除", type: "success" })
          this.$router.replace({ path: `list` })
        }).catch((e) => {
          console.log(e)
          this.$message.error(e || "系统错误")
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.wrap {
  width: 640px;
  margin: 0 auto;
  background: #fff;
  line-height: 2;
}
dl {
  padding: 20px;
  dt {
    margin-top: 10px;
    padding: 10px 0;
    font-weight: bold;
    font-size: 16px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    tr {
      td {
        border: 1px solid;
        list-style: none;
        padding: 5px 10px;
      }
    }
  }
}
.ft {
  text-align: center;
}
</style>